import { IPeriod } from '@shared/interfaces';
import { NavTabs } from '@shared/tabs/NavTabs';
import { ITeamTypeType } from '../interfaces';
import { Teams } from './Teams/Teams';
import { TeamTypes } from './TeamTypes/TeamTypes';
import { CopyTeams } from './CopyTeams/CopyTeams';

export interface ITeamManagerTabsProps {
  periods: IPeriod[];
  teamTypes: ITeamTypeType[];
}

export const TeamManagerTabs = ({ periods, teamTypes }: ITeamManagerTabsProps) => {
  const teams = <Teams periods={periods} teamTypes={teamTypes} />;
  const types = <TeamTypes teamTypes={teamTypes} />;
  const copyTeams = <CopyTeams periods={periods} />;

  const tabs = [
    {
      name: 'Teams',
      component: teams,
    },
    {
      name: 'Team Types',
      component: types,
    },
    {
      name: 'Copy Teams',
      component: copyTeams,
    },
  ];

  return <NavTabs data={tabs} loading={!periods || !teamTypes} />;
};
